(function () {
  var STORAGE_KEY = 'syrvain-theme';
  var mql = window.matchMedia('(prefers-color-scheme: dark)');

  function getPreference() {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'system';
    } catch (e) {
      return 'system';
    }
  }

  function resolve(pref) {
    return pref === 'system' ? (mql.matches ? 'dark' : 'light') : pref;
  }

  function applyPreference(pref) {
    var resolved = resolve(pref);
    document.documentElement.setAttribute('data-syrvain-theme', resolved);
    if (window.SyrvainDither && window.SyrvainDither.setBack) {
      window.SyrvainDither.setBack(resolved === 'light' ? '#FFFFFF' : '#0A0A0A');
    }
    try {
      localStorage.setItem(STORAGE_KEY, pref);
    } catch (e) {}
  }

  function init() {
    var pref = getPreference();
    var inputs = document.querySelectorAll('.syrvain-theme-switcher__input');

    inputs.forEach(function (input) {
      input.checked = input.value === pref;
      input.addEventListener('change', function () {
        if (input.checked) applyPreference(input.value);
      });
    });
  }

  mql.addEventListener('change', function () {
    if (getPreference() === 'system') applyPreference('system');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
